import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { GuidaGridChoice, GuidaLabel } from '@inter-ikea-guida/framework';
import cornerImgUrl from '../../assets/corner_icon.png';
import singleImgUrl from '../../assets/single_icon.png';
import { useAppDispatch } from '../../store';
import { selectRadio } from '../../store/app';
import { getFormState, getCMSState } from '../../store/app/selectors';
import { getTranslation } from '../../store/i18n/selectors';
import { WALL, SINGLE_WALL } from '../../utils';
import { sendInsightsEvent } from '../../utils/insights/sendInsights';
export const LayoutSelector = () => {
    const translate = useSelector(getTranslation);
    const formState = useSelector(getFormState);
    const cmsState = useSelector(getCMSState);
    const dispatch = useAppDispatch();
    const onWallSelect = (value) => {
        dispatch(selectRadio({
            id: WALL,
            value
        }));
        window.scrollTo({ top: 0, behavior: 'smooth' });
        sendInsightsEvent('whatIsMe', 'select_wall', { wall: value });
    };
    const wallFormObject = cmsState.form.find(formItem => formItem.id === 'wall');
    if (!wallFormObject) {
        return _jsx(_Fragment, {});
    }
    const wallIndex = wallFormObject?.options.findIndex(o => o.value === formState.wall);
    const preselectedChoice = Math.max(wallIndex, 0);
    return (_jsxs(_Fragment, { children: [_jsx(GuidaLabel, { htmlFor: wallFormObject.id, text: translate(wallFormObject?.label) }), _jsx(GuidaGridChoice, { ariaLabel: translate(wallFormObject?.label), options: wallFormObject.options.map(opt => ({
                    id: opt.id,
                    title: translate(opt.label),
                    image: opt.id === SINGLE_WALL ? { src: singleImgUrl, alt: '' } : { src: cornerImgUrl, alt: '' }
                })), onOptionClick: e => onWallSelect(e), preselectedChoice: preselectedChoice, dataTestId: 'layout-selector' })] }));
};
//# sourceMappingURL=LayoutSelector.js.map